<template>
  <div :style="scrollViewStyle">
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <appl-menu-icon
          :propsParam="{
            applCd: GET_SEARCH_APPL_CD,
            gntGubunCd: GET_GNT_GUBUN_CD,
          }"
        ></appl-menu-icon>
        {{ menuTitle }}
      </v-col>
    </v-row>
    <v-list>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, i) in menuList"
          :key="i"
          class="gntType-item"
        >
          <v-list-item-content @click="selectMenu(item)">
            <!-- 대체휴가 -->
            <v-list-item-title v-if="isAlterVacation">
              <span class="date">{{ item.code }}</span>
              <span class="time divider">{{ item.codeNm }}</span>
              <span class="hour divider font-weight-bold">
                {{ item.hour }}{{ $t('시간') }}
              </span>
            </v-list-item-title>
            <!-- 근태 -->
            <v-list-item-title v-else v-text="item.codeNm" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <!-- empty Data component -->
    <no-applicable v-if="emptyDataFlag" v-bind:text="emptyDataText" />
  </div>
</template>
<script>
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import NoApplicable from '@/components/common/NoApplicable.vue';

import { getHolWork } from '@/api/application';
import { mapGetters, mapMutations } from 'vuex';
import { getWorkCommonCode } from '@/api/code';
import routerNames from '@/const/routerConstants';
import applCode from '@/const/applCodeConstants';
// import messageConstants from '@/const/messageConstants.js';

import dayjs from 'dayjs';
/**  */
export default {
  data: () => ({
    // emptyDataText: messageConstants.emptyDataMsg_1,
    emptyDataText: '휴일 근무일이 없습니다.',
    gntGubunCdMenu: [],
    holWorkList: [],

    emptyDataFlag: false,
  }),
  computed: {
    ...mapGetters('CODE', ['GET_GNT_CD_LIST', 'GET_GNT_CD_OBJ']),
    ...mapGetters('ELA', [
      'GET_GNT_GUBUN_CD',
      'GET_SEARCH_APPL_CD',
      'GET_GNT_CD',
      'GET_VACATION_PARAM',
    ]),
    /** 2025.07.14 스크롤 부분 추가 */
    scrollViewStyle() {
      const maxHeight = window.innerHeight - this.$store.getters.HEIGHT_TITLE;
      return {
        maxHeight: `${maxHeight}px`,
        overflowY: 'auto', // 세로 스크롤 활성화
        WebkitOverflowScrolling: 'touch', // 모바일 부드러운 스크롤
      };
    },
    /* 대체휴가인지 */
    isAlterVacation() {
      return this.GET_GNT_GUBUN_CD === '11';
    },

    /* 메뉴 제목 */
    menuTitle() {
      if (this.isAlterVacation) {
        // 대체휴가
        return this.$i18n.t('휴일근무일을 선택해주세요.');
        // 근태
      } else {
        return this.$i18n.t('근태종류를 선택해주세요.');
      }
    },

    /* 메뉴 목록 */
    menuList() {
      return this.isAlterVacation ? this.holWorkList : this.gntGubunCdMenu;
    },
  },

  methods: {
    ...mapMutations('ELA', [
      'SET_GNT_GUBUN_CD',
      'SET_ALTER_VACATION',
      'SET_APP_MENU',
      'SET_S_YMD',
      'SET_E_YMD',
      'SET_HOL_WORK_YMD', //2025.03.10 테스트로 커밋
      'SET_GNT_CD',
      'SET_HALF_YN',
      'SET_APPL_ORG_LVL',
    ]),
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP']),
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    /* 신청서 선택 */
    async selectMenu(menu) {
      this.SET_APP_MENU({
        gubun: 'works',
        applCd: applCode.Vacation,
        gntGubunCd: menu.code,
        menuNm: menu.codeNm,
      });

      // 신청서의 예외 결재레벨 분리저장
      this.SET_APPL_ORG_LVL(menu.orgLvl);

      // 대체휴가
      if (this.isAlterVacation) {
        // 선택한 휴일근무일 저장
        this.SET_ALTER_VACATION(menu);
        // 대체휴가 정보가 있는 경우
        if (menu.alterYmd !== null) {
          this.SET_S_YMD(dayjs(menu.alterYmd).format('YYYYMMDD'));
          this.SET_E_YMD(dayjs(menu.alterYmd).format('YYYYMMDD'));
          this.SET_HOL_WORK_YMD(dayjs(menu.code).format('YYYYMMDD'));
          this.SET_GNT_CODE_TMP(menu.alterGntCd);
          this.SET_GNT_CD(this.GET_GNT_CD_OBJ);
          this.SET_HALF_YN();
          await this.$store.dispatch('ELA/FETCH_HOLI_CNT');
          this.$router.push(routerNames.ExtraOptions);
        } else {
          this.$router.push(routerNames.GntTypeMenu);
        }
      } else {
        // 선택한 근태구분 저장
        this.SET_GNT_GUBUN_CD(menu.code);

        this.$router.push(routerNames.GntTypeMenu);
      }
    },

    /* 휴일근무일 조회 */
    async fetchHolWork() {
      try {
        this.holWorkList = [];
        const param = this.GET_VACATION_PARAM;
        param['applStatusCd'] = '';
        const response = await getHolWork(param);
        const responseList = response.data.data;
        // 데이터 가공
        responseList.forEach(element => {
          let codeNm = element.codeNm;
          element['code'] = dayjs(element.code).format('YYYY-MM-DD');
          element['codeNm'] = codeNm.substring(
            codeNm.indexOf('(') + 1,
            codeNm.indexOf(')'),
          );
        });
        this.holWorkList = responseList;
        this.emptyDataFlag = this.holWorkList.length === 0;

        this.OFF_APP_SPINNER();
      } catch (error) {
        console.log(error);
      }
    },

    /* 근태종류 목록 조회 (gntGubunCd) */
    async fetchGntGubunCdMenu() {
      const doNotUse = ['10', '19', '1', '41', '11', '21'];
      // 보상, 출장, 연차, 배우자출산, 대체, 교육훈련은 별도 신청서메뉴 사용중으로 제외

      this.gntGubunCdMenu = [];

      try {
        const response = await getWorkCommonCode({
          cmd: 'mobileGntGubunCdApp', //'gntGubunCdApp',
          vacationApp: 'Y',
        });

        response.data.data
          .filter(item => !doNotUse.includes(item.code))
          .map(item => {
            item.applCd = '22';
            this.gntGubunCdMenu.push(item);
          });

        this.OFF_APP_SPINNER();
      } catch (error) {
        console.log(error);
      }
    },

    async fetchHolWorkGntCd() {
      try {
        await this.$store.dispatch('CODE/FETCH_GNT_CD', {
          cmd: 'gntCdApp',
          searchGntGubunCd: this.GET_GNT_GUBUN_CD,
        });
        this.SET_GNT_CD(this.GET_GNT_CD_LIST[0]);
        this.OFF_APP_SPINNER();
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.ON_APP_SPINNER(); // 스피너 ON

    // 초기 데이터 조회
    if (this.isAlterVacation) {
      this.fetchHolWork();
      this.fetchHolWorkGntCd();
    } else {
      this.fetchGntGubunCdMenu();
    }
  },
  components: {
    ApplMenuIcon,
    NoApplicable,
  },
};
</script>
<style>
.row.title-wrap {
  margin-bottom: 10px;
}
.chip-wrap {
  padding: 0px 22px 20px;
}
.gntType-item {
  padding-left: 54px;
  padding-right: 54px;
}
.divider::before {
  margin: 0 10px;
}
</style>
